<ng-container
    *ngIf="{
        templateConfiguration: templateConfiguration$ | async,
        direction: direction$ | async,
        isMobile: isMobile$ | async,
        desktopLarge: desktopLarge$ | async
    } as data"
>
    <div
        class="{{ data.templateConfiguration.classes.parent }} {{ templateNameFirst }} {{ templateName }} {{ skeletonNoDetails }} monoproducto-slider"
        [class.is-rtl]="data.direction === 'rtl'"
        *ngIf="data.templateConfiguration"
    >
        <ng-container *ngIf="data.isMobile === false && isBrowser; else swiperSSR">
            <div class="grid-swiper-wrap {{ data.templateConfiguration.classes.desktop }}">
                <ng-container *ngIf="data.direction">
                    <swiper
                        #swiper
                        *ngIf="products?.length > 0"
                        [dir]="data.direction"
                        [hidden]="swiperNotIsReady"
                        class="swiper-width"
                        [ngClass]="data.templateConfiguration.classes.swiper"
                        [slidesPerView]="data.templateConfiguration.slidesPerView"
                        [navigation]="data.templateConfiguration.navigation ? navigationOptions : null"
                        [spaceBetween]="
                            data.desktopLarge ? data.templateConfiguration.spaceBetween.desktopLarge : data.templateConfiguration.spaceBetween.desktop
                        "
                        [scrollbar]="{
                            el: '.swiper-scrollbar',
                            hide: data.templateConfiguration.hedeScrollBar
                        }"
                        [centerInsufficientSlides]="data.templateConfiguration.centerInsufficientSlides"
                    >
                        <ng-template swiperSlide *ngFor="let product of products">
                            <ng-container *ngIf="data.templateConfiguration.skLoad">
                                <div class="{{ data.templateConfiguration.skLoad }}">
                                    <ng-container *ngTemplateOutlet="productTemplate; context: { product: product, data: data }"></ng-container>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!data.templateConfiguration.skLoad">
                                <ng-container *ngTemplateOutlet="productTemplate; context: { product: product, data: data }"></ng-container>
                            </ng-container>
                        </ng-template>
                    </swiper>
                </ng-container>
            </div>
            <div
                class="{{ data.templateConfiguration.classes.navigationArrows }} is-flex content-end sm:hidden mb-40 mr-40"
                *ngIf="data.templateConfiguration.navigation"
            >
                <div class="swiper-nav-left swiper-{{ uuid }}-nav-left swiper-carrousel-prev cursor-pointer">
                    @if ((direction$ | async) === 'rtl') {
                        <ng-container *ngTemplateOutlet="arrowLeft"></ng-container>
                    } @else {
                        <ng-container *ngTemplateOutlet="arrowRight"></ng-container>
                    }
                </div>
                <div class="swiper-nav-right swiper-{{ uuid }}-nav-right swiper-carrousel-next cursor-pointer">
                    @if ((direction$ | async) === 'rtl') {
                        <ng-container *ngTemplateOutlet="arrowRight"></ng-container>
                    } @else {
                        <ng-container *ngTemplateOutlet="arrowLeft"></ng-container>
                    }
                </div>
            </div>
        </ng-container>
        <ng-template #swiperSSR>
            <div
                class="grid-swiper-wrap swiper-nat"
                [ngClass]="data.isMobile ? data.templateConfiguration.classes.mobile : !isBrowser ? data.templateConfiguration.classes.ssr : ''"
            >
                <div class="swiper-nat-inner is-flex">
                    <div class="swiper-thumbs {{ data.templateConfiguration.skLoadMobile }}" *ngFor="let product of products">
                        <ng-container *ngTemplateOutlet="productTemplate; context: { product: product, data: data }"></ng-container>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</ng-container>

<ng-template #productTemplate let-product="product" let-data="data">
    <product-view
        class="{{ data.templateConfiguration.classes.product }}"
        [productId]="product"
        [config]="data.templateConfiguration.templateConfigurations"
        [categoryConfig]="categoryConfiguration"
        [productStyle]="productStyle"
        [defaultImageType]="elementDefaultImageTypes?.[product]"
    ></product-view>
</ng-template>

<ng-template #arrowLeft>
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" [style.fill]="catalogStyles?.fontColor">
        <path
            d="M4.64645 1.64645C4.45118 1.84171 4.45118 2.15829 4.64645 2.35355L10.2929 8L4.64645 13.6464C4.45118 13.8417 4.45119 14.1583 4.64645 14.3536C4.84171 14.5488 5.15829 14.5488 5.35355 14.3536L11.7071 8L5.35355 1.64645C5.15829 1.45118 4.84171 1.45118 4.64645 1.64645Z"
        ></path>
    </svg>
</ng-template>

<ng-template #arrowRight>
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" [style.fill]="catalogStyles?.fontColor">
        <path
            d="M11.3536 1.64645C11.5488 1.84171 11.5488 2.15829 11.3536 2.35355L5.70711 8L11.3536 13.6464C11.5488 13.8417 11.5488 14.1583 11.3536 14.3536C11.1583 14.5488 10.8417 14.5488 10.6464 14.3536L4.29289 8L10.6464 1.64645C10.8417 1.45118 11.1583 1.45118 11.3536 1.64645Z"
        ></path>
    </svg>
</ng-template>
